module.exports = __webpack_public_path__ + "img/home-duckrabbit_lg.28a75fbe.png";